import { useTranslation } from 'react-i18next';
import React from 'react';
import cx from 'clsx';

import { IconActionImport } from '@/assets/stream';
import { Modal } from '@/components';
import { useSwitch } from '@/hooks';

import { LinkParsedContentMono } from '../../Content';
import { useActionEligible } from '../hook';
import { ActionWrapper, ActionProps } from './Wrapper';
import style from './index.module.scss';

export const DataImport = (props: ActionProps) => {
  const { data: action } = props;

  const { on, turnOn, turnOff } = useSwitch();

  return (
    <>
      <ActionWrapper
        {...props}
        onActionClick={turnOn}
        avatar={<IconActionImport className={style.actionIcon} />}>
        {action.data.title}
      </ActionWrapper>
      {on ? <ConfirmModal action={action} turnOff={turnOff} /> : null}
    </>
  );
};

const { CommonModal } = Modal;

const ConfirmModal = ({
  action,
  turnOff,
}: {
  turnOff: () => void;
  action: ActionProps['data'];
}) => {
  const { t } = useTranslation();

  const { data, isLoading } = useActionEligible(action.id);
  const isEligible = data?.is_eligible;

  return (
    <CommonModal turnOff={turnOff} containerClassName={style.confirmModal}>
      <div className={style.cmTitle}>
        <IconActionImport className={style.actionIcon} />
        {action.data.title}
      </div>
      <div className={style.cmFieldRow}>
        <span className={style.cmfTitle}>{t('Actions_ChainUser.154b66q')}</span>
        <span className={cx(style.cmfValue, isEligible && style.isUsed)}>
          {isLoading
            ? '-'
            : isEligible
              ? t('Actions_DataImport.eligible')
              : t('Actions_DataImport.notEligible')}
        </span>
      </div>
      {action.data.desc ? (
        <div className={style.cmField}>
          <div className={style.cmfTitle}>{t('Actions_ChainUser.description')}</div>
          <div className={style.cmfBgValue}>
            <LinkParsedContentMono content={action.data.desc} linkClassnames={style.cmLinkParsed} />
          </div>
        </div>
      ) : null}
      <div className={style.cmField}>
        <div className={style.cmfTitle}>{t('Actions_DataImport.actionLinks')}</div>
        <LinkParsedContentMono content={action.data.related_link} linkClassnames={style.cmLink} />
      </div>
    </CommonModal>
  );
};
